/**
 * Impersonation ("bekijk als") helpers.
 *
 * Een admin/manager kan tijdelijk inloggen als een partner-gebruiker
 * (locatiebeheerder) om te zien wat die persoon ziet. Het originele
 * admin-token wordt bewaard onder `admin_token` zodat we altijd veilig
 * kunnen terugschakelen. De hele auth-identiteit van de app wordt gedreven
 * door localStorage["token"], dus wisselen = token omzetten + herladen.
 */

const TOKEN_KEY = "token";
const ADMIN_TOKEN_KEY = "admin_token";
const LABEL_KEY = "impersonation_label";

export function isImpersonating() {
  return !!localStorage.getItem(ADMIN_TOKEN_KEY);
}

/**
 * Wis alle impersonatie-state (zonder te herladen). Wordt o.a. bij uitloggen
 * aangeroepen zodat een bewaard admin-token niet naar een volgende sessie lekt.
 */
export function clearImpersonationState() {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(LABEL_KEY);
}

export function getImpersonationLabel() {
  return localStorage.getItem(LABEL_KEY) || "";
}

/**
 * Start impersonatie: bewaar het huidige admin-token, zet het partner-token
 * als actief token en herlaad de app vanaf "/".
 */
export function startImpersonation(impersonationToken, label) {
  const current = localStorage.getItem(TOKEN_KEY);
  if (current) localStorage.setItem(ADMIN_TOKEN_KEY, current);
  if (label) localStorage.setItem(LABEL_KEY, label);
  localStorage.setItem(TOKEN_KEY, impersonationToken);
  window.location.replace("/");
}

/**
 * Stop impersonatie: herstel het admin-token en herlaad. Valt terug op de
 * userorganisaties-lijst als er om welke reden dan ook geen admin-token is.
 */
export function stopImpersonation() {
  const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (adminToken) {
    localStorage.setItem(TOKEN_KEY, adminToken);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(LABEL_KEY);
  window.location.replace("/admin/userorganisaties");
}
